import { render, staticRenderFns } from "./ApexHeatMapCharts.vue?vue&type=template&id=5d563a2d"
import script from "./ApexHeatMapCharts.vue?vue&type=script&lang=js"
export * from "./ApexHeatMapCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports